export default __webpack_public_path__ + "static/media/trv.e5804c95.jpg";